export default "__VITE_ASSET__DJiwEc6O__"